import {Partner, PartnerListFilter} from '../../models/partner.model';
import {ValidationError} from '../../models/validation-error.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace PartnerActions {
    export class GetById {
        static readonly type = 'PartnerActions.GetById';

        constructor(public id: number) {}
    }

    export class GetListPage {
        static readonly type = 'PartnerActions.GetListPage';

        constructor(public params?: SearchQueryParams) {}
    }

    export class Activate {
        static readonly type = 'PartnerActions.Activate';

        constructor(public id: number) {}
    }

    export class Deactivate {
        static readonly type = 'PartnerActions.Deactivate';

        constructor(public id: number) {}
    }

    export class DeactivateSales {
        static readonly type = 'PartnerActions.DeactivateSales';

        constructor(public id: number) {}
    }

    export class Add {
        static readonly type = 'PartnerActions.Add';

        constructor(public readonly partner: Partner) {}
    }

    export class Update {
        static readonly type = 'PartnerActions.Update';

        constructor(public readonly partner: Partner) {}
    }

    export class FormFailure {
        static readonly type = 'PartnerActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {}
    }

    export class FieldList {
        static readonly type = 'PartnerActions.FieldList';

        constructor(public readonly filters?: PartnerListFilter) {}
    }

    export class Clear {
        static readonly type = 'PartnerActions.Clear';
    }

    export class ListClear {
        static readonly type = 'PartnerActions.ListClear';
    }
}

